import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[labelHelper]' // tslint:disable-line
})
export class LabelHelperDirective<T = any> {
  @Input() public labelHelper;
  constructor(public templateRef: TemplateRef<T>) {}
}
